import React from "react";
import { isIntranetPath } from "lib/routing";
import useContentCompanyWebLogoResizer from "lib/hooks/useContentCompanyWebLogoResizer";
import { i18n } from "app/i18n/i18n";
import logoSrc from "./ccw_logo.png";
import "./ContentCompanyLogoNew.scss";

const CCW_URL = "http://websquare.intranet.jp.nomura.com/website83/ccw/index.html?link=GRP";
const shouldShowLogo = () => i18n.getLanguage() === "ja" && isIntranetPath();

export function ContentCompanyLogoNew() {
  const { logoTriangleStyle } = useContentCompanyWebLogoResizer();

  if (!shouldShowLogo()) return null;

  return (
    <div className="logo-container">
      <a href={CCW_URL} title="当リンクは社内限で表示" target="_blank" rel="noopener noreferrer">
        <img className="link-image" src={logoSrc} alt="Content Company Logo" />
        <div className="logo-triangle" style={logoTriangleStyle} />
      </a>
    </div>
  );
}
